// Helper function to convert values to numbers with proper validation
function toNum(value) {
    if (value === null || value === undefined) {
        return null;
    }
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
}

// Helper function to extract rep data values, preferring rep_data over legacy fields
// Returns null for non-finite results (NaN/Infinity) and coerces values to numbers
export default function getRepValue(rep, field) {
    if (!rep || !field) {
        return null;
    }

    // Only use rep_data fields for tether sensors, fallback to legacy fields for backward compatibility
    // For other sensor types, they'll have different rep_data structures
    const isTetherSensor = rep.sensor_type === 'REPONE_TETHER' || rep.sensor_type === undefined || rep.sensor_type === null;
    const repData = (isTetherSensor && rep.rep_data) || {};
    
    let value;
    switch (field) {
        case 'average_velocity':
            value = repData.average_velocity ?? rep.average_velocity;
            break;
        case 'peak_velocity':
            value = repData.peak_velocity ?? rep.peak_velocity;
            break;
        case 'rom':
            value = repData.rom ?? rep.rom;
            break;
        case 'peak_height':
            value = repData.peak_height ?? rep.peak_height;
            break;
        case 'duration':
            value = repData.duration ?? rep.duration;
            break;
        default:
            return null;
    }
    
    return toNum(value);
}